/* eslint-disable */
// Environment-aware Cognito configuration.
// Selected at build time via REACT_APP_BUILD_ENV.

const envConfigs = {
  dev: {
    aws_user_pools_id: 'ap-southeast-2_xeOEMjFbt',
    aws_user_pools_web_client_id: '1dtkq4cubilfgrcasdibcpeqvk',
    oauth: { domain: 'auth.dev.liively.app' },
  },
  stage: {
    aws_user_pools_id: 'ap-southeast-2_ujNQb6HAe',
    aws_user_pools_web_client_id: '2nfujqtth89eos0pal1ug6qicc',
    oauth: { domain: 'auth.stage.liive.ly' },
  },
  prod: {
    aws_user_pools_id: 'ap-southeast-2_VmaefnXev',
    aws_user_pools_web_client_id: 'qjalirnlh08vr5kp7sc0j9oba',
    oauth: { domain: 'auth.prod.liively.app' },
  },
};

const env = process.env.REACT_APP_BUILD_ENV || 'dev';
const config = envConfigs[env] || envConfigs['dev'];

const awsmobile = {
  aws_project_region: 'ap-southeast-2',
  aws_cognito_region: 'ap-southeast-2',
  ...config,
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL', 'PHONE_NUMBER'],
};

export default awsmobile;
